import React from "react";
import ReactDOM from "react-dom";
import Proptypes from "prop-types";
import axios from "axios";
import "intersection-observer";
import Observer from "@researchgate/react-intersection-observer";

class ArticleSection extends React.Component {
    static defaultProps = {
        autoAttached: true, //is it auto attached or a specific article?
        article: null, //either the reference article or the article to display depending on if it auto attached or not
        preview: false,
        order: "first" //which lazy loaded article on the page is it?
    };

    static propTypes = {
        autoAttached: Proptypes.bool,
        article: Proptypes.string,
        preview: Proptypes.bool,
        order: Proptypes.string
    };

    state = {
        loaded: false,
        sectionData: null,
        initialized: false
    };

    fetchSection = (event) => {
        if(event.isIntersecting && this.state.loaded && !this.state.initialized) {
            this.refreshAds(this.refs.section.querySelectorAll("[data-zone]"));

            // add article to url updater
            let section = this.refs.section;
            let article = section.querySelector("#ArticleView");
            let addChangeURLEvent = new CustomEvent("addChangeURL", {detail: article});

            window.dispatchEvent(addChangeURLEvent);
            this.setState({initialized: true});
        }
    };

    loadArticle = () => {
        let request = null;
        if(this.props.autoAttached) {
            request = axios.get("/api/article-section", {
                params: {
                    relatedTags: JSON.parse(this.props.article).tags.map(tag => tag.tagNo).join(","),
                    preview: JSON.stringify(this.props.preview),
                    order: this.props.order
                }
            });
        } else {
            request = axios.get(`/api/article-section/${this.props.article}`, {
                params: {
                    preview: this.props.preview
                }
            });
        }
        if(request) {
            request.then(response => {
                this.setState({
                    sectionData: response.data.length ? response.data : null,
                    loaded: true
                });

                if(response.data.length) {
                    let section = this.refs.section;
                    section.parentNode.classList.add("isLoaded");
                } else {
                    ReactDOM.findDOMNode(this).parentNode.classList.add("isEmpty");
                }
            });
        }
    }

    componentDidMount() {
        this.loadArticle();
    }

    refreshAds = (adSlots) => {
        let loadNewAdsEvent = new CustomEvent("loadNewAds", {detail: adSlots});

        window.dispatchEvent(loadNewAdsEvent);
    }

    createMarkup = () => {
        return {
            __html: this.state.sectionData
        };
    }

    render() {
        const sectionOptions = {
            onChange: this.fetchSection,
            rootMargin: "0% 0% 75%",
        };

        return (
            <div ref="section">
                <Observer {...sectionOptions}>
                    <div dangerouslySetInnerHTML={this.createMarkup()} />
                </Observer>
            </div>
        );
    }
}

export default ArticleSection;
